export var ICON_BUTTON_TYPES = {
  "default": 'icon-button',
  white: 'icon-button-white',
  dark: 'icon-button-dark'
};
export var ICON_BUTTON_XS_TYPES = {
  "default": 'icon-button-xs',
  white: 'icon-button-xs-white',
  dark: 'icon-button-xs-dark'
};